<div class="tour-card-media">
  <img [src]="tour.url" [alt]="tour.title || 'Tour image'" class="tour-card-image">
  <app-shopping-cart [tour]="tour"/>
</div>

<div class="tour-card-content">
  <span class="tour-card-price">
    {{ "Price until 4 people" | translate }} - {{ tour.price }}AMD
  </span>

<!--  <span class="tour-card-price secondary">-->
<!--    {{ "Price from 5 until 7 people" | translate }} - ${{ tour.groupPrice }}-->
<!--  </span>-->

  <h2 class="tour-card-title">{{ tour.title | translate }}</h2>
  <p class="tour-card-description">{{ tour.description | translate }}</p>
  <span class="tour-card-id">{{ "Tour id" | translate }} - {{ tour.id }}</span>
</div>

